module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1051-e4859a4cd47d1f905b0e5364d1ce5e6b.png";